var map = {
	"./mtn-cg-fr/assets/score-predictor-header.png": "ecab",
	"./vc-egy-ar/assets/score-predictor-header.png": "ae06",
	"./vc-za-en/assets/score-predictor-header.png": "9982"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bbc5";